import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLanguage();
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#f7f7f5] py-20 lg:py-28">
      <div className="mx-auto max-w-3xl px-5 lg:px-10">
        <Reveal className="mb-10 text-center">
          <span className="eyebrow text-[11px] text-[#999]">{t.nav.faq}</span>
          <h2 className="mt-3 font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.faq.title}</h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map(([q, a], i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#e2e2e2]">
                <AccordionTrigger className="py-5 text-left font-body text-base font-normal text-[#111] hover:no-underline">
                  {q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-sm leading-relaxed text-[#666]">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
